<span class="stt-marker-icon" [class]="'stt-marker-icon--' + type()">
  <ftr-icon [color]="color()" [icon]="icon()" size="Text" [interactive]="interactive()" (click)="click()"></ftr-icon>
</span>
